namespace advisorop.components.meetinghub {
    export class CuAdvisorMeetingAvailabilityController {
        advisor: domains.IAdvisor;
        onMeetingAvailabilitySet: any;
        schedules: Array<domains.IMeetingAvailabilityScheduleInline> = new Array<domains.IMeetingAvailabilityScheduleInline>();
        msGraphCalendars: Array<domains.ICalendar> = new Array<domains.ICalendar>();
        meetingHubCalendars: Array<domains.IMeetingHubCalendar> = new Array<domains.IMeetingHubCalendar>();
        isAvailabilitySet: boolean;
        saving: boolean = false;

        schedulesToDelete: Array<number> = new Array<number>();
        days: any[] = [{day: 0, name: 'Sunday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>() },
            { day: 1, name: 'Monday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  },
            { day: 2, name: 'Tueday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  },
            { day: 3, name: 'Wednesday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  },
            { day: 4, name: 'Thursday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  },
            { day: 5, name: 'Friday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  },
            { day: 6, name: 'Saturday', available: false, schedules: new Array<domains.IMeetingAvailabilityScheduleInline>()  }];

        dboStartTime: DevExpress.ui.dxDateBoxOptions;

        constructor(private generalService: services.GeneralService, private meetingHubService: services.MeetingHubService, private advisorService: services.AdvisorService, private $q: ng.IQService) {

        }

        loadAvailability(): void {
            this.schedules = [];
            this.meetingHubService.getAvailableSchedules().then(response => {
                console.log(response);
                if (response.data.length == 0) {
                    this.initializeDefaultSchedules()
                } else {
                    this.schedules = response.data.concat();
                    this.schedules.forEach(schedule => {
                        this.days[schedule.day].available = !schedule.unavailable;
                        this.days[schedule.day].schedules.push(schedule);
                    });
                }
            })
        }

        loadCalendars(): void {
            this.msGraphCalendars = new Array<domains.ICalendar>();
            this.meetingHubCalendars = new Array<domains.IMeetingHubCalendar>();
            var msGraphCalendarPromise = this.advisorService.getAdvisorCalenders();
            var mhCalendarPromise = this.meetingHubService.getCalendars();

            this.$q.all([mhCalendarPromise, msGraphCalendarPromise]).then(result => {
                if (result[0].success) {
                    this.meetingHubCalendars = result[0].data.concat();
                }
                if (result[1].success) {
                    this.msGraphCalendars = result[1].data.concat();
                }
                // get new advisor calenders
                var newMSGraphCalendars = this.msGraphCalendars.filter(c => !this.meetingHubCalendars.some(m => m.calendarId == c.idString));
                if (newMSGraphCalendars.length > 0) {
                    for (var calendarToAdd of newMSGraphCalendars) {
                        var newMeetingHubCalendar: domains.IMeetingHubCalendar = {
                            calendarId: calendarToAdd.idString,
                            calendarName: calendarToAdd.name,
                            color: calendarToAdd.color,
                            owner: calendarToAdd.owner,
                            useWithMeetingHub: false
                        }

                        this.meetingHubCalendars.push(newMeetingHubCalendar);
                    }
                }

                var meetingHubCalendarsToDelete = this.meetingHubCalendars.filter(c => !this.msGraphCalendars.some(m => m.idString == c.calendarId));

                if (meetingHubCalendarsToDelete.length > 0) {
                    for (var calendarToDelete of meetingHubCalendarsToDelete) {
                        this.meetingHubCalendars.splice(this.meetingHubCalendars.indexOf(calendarToDelete), 1);
                    }
                }
                console.log(result)
                //this.msGraphCalendars = result.data.concat();
            })
        }

        getSchedulesFor(day: number): Array<domains.IMeetingAvailabilityScheduleInline> {
            var schedules = this.schedules.filter(s => s.day == day);
            return schedules;
        }

        onAvailableChange(day: any): void {
            console.log(day);
            day.schedules.forEach(s => s.unavailable = !day.available);
        }

        addTime(day: any): void {
            var schedulesForDay = this.getSchedulesFor(day.day);

            var timesCount = schedulesForDay.length;
            var newTime: domains.IMeetingAvailabilityScheduleInline = {
                day: this.days.indexOf(day),
                startTime: new Date(0, 0, 0, 9, 0, 0),
                endTime: new Date(0, 0, 0, 17, 0, 0),
                unavailable: false,
                id: -1,
                advisorId: -1,
            }
            if (timesCount > 0) {
                var latestTime = schedulesForDay[timesCount - 1];
                newTime.startTime = new Date(latestTime.endTime);
                newTime.advisorId = latestTime.advisorId;
            }
            this.schedules.push(newTime);
            day.schedules = this.getSchedulesFor(day.day);
        }

        deleteTime(schedule: domains.IMeetingAvailabilityScheduleInline): void {
            var day = schedule.day;
            var indexToDelete = this.schedules.indexOf(schedule);
            if (indexToDelete >= 0) {
                if (this.schedules[indexToDelete].id > -1) {
                    this.schedulesToDelete.push(this.schedules[indexToDelete].id);
                }
                this.schedules.splice(indexToDelete, 1);
                this.days[day].schedules = this.getSchedulesFor(day);
                this.days[day].available = this.days[day].available && this.days[day].schedules.length > 0;
            }
        }

        createUpdateAvailableSchedules(schedules: Array<domains.IMeetingAvailabilityScheduleInline>): void {
            this.meetingHubService.createUpdateAvailableSchedules(schedules).then(response => {
                this.onMeetingAvailabilitySet();
            }, err => this.generalService.showError(err)).finally(() => {
                this.saving = false;
            })
        }

        onSave(): void {
            this.saving = true;
            if (this.schedulesToDelete.length > 0) {
                this.meetingHubService.deleteAvailableSchedules(this.schedulesToDelete).then(response => {
                    this.schedulesToDelete = [];
                    this.createUpdateAvailableSchedules(this.schedules);
                }, err => {
                    this.generalService.showError(err);
                    this.saving = false;
                })
            } else {
                this.createUpdateAvailableSchedules(this.schedules);
            }
            this.meetingHubService.createUpdateCalendars(this.meetingHubCalendars).then(result => {
                this.meetingHubCalendars = [];
                this.meetingHubCalendars = result.data.concat();
            })
        }

        onCancel(): void {
            this.loadAvailability();
            this.loadCalendars();
        }

        initializeDefaultSchedules(): void {
            this.schedules = [];
            for (let day in domains.DaysOfWeek) {
                if (!isNaN(Number(day))) {
                    let schedule: domains.IMeetingAvailabilityScheduleInline = {
                        day: Number(day),
                        startTime: new Date(0, 0, 0, 9, 0, 0),
                        endTime: new Date(0, 0, 0, 17, 0, 0),
                        unavailable: (Number(day) == domains.DaysOfWeek.SATURDAY || Number(day) == domains.DaysOfWeek.SUNDAY) ? true : false,
                        advisorId: -1,
                        id: -1
                    };

                    this.days[schedule.day].available = !schedule.unavailable;
                    this.schedules.push(schedule);
                    this.days[schedule.day].schedules = this.getSchedulesFor(schedule.day);
                }
            }
        }

        $onInit(): void {
            this.loadAvailability();
            this.loadCalendars();
        }

        $onChanges(evt): void {
            if (this.advisor != undefined) {
            }
        }
    }

    class CuAdvisorMeetingAvailability implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                advisor: '<',
                isAvailabilitySet: '<',
                onMeetingAvailabilitySet: '&'
            };
            this.controller = [`generalService`, `meetingHubService`, `advisorService`, `$q`, CuAdvisorMeetingAvailabilityController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/meeting-hub-module/components/cu-advisor-meeting-availability.html`;
        }
    }
    angular.module(Constants.APP).component(`cuAdvisorMeetingAvailability`, new CuAdvisorMeetingAvailability());
}